// extracted by mini-css-extract-plugin
export default {"page":"DY-z","cartModal":"EY-z","checkout":"FY-z","placeholder":"GY-z","account":"HY-z"};